import Alpine from "alpinejs";
import Splide from "@splidejs/splide";
import { URLHash } from "@splidejs/splide-extension-url-hash";
import clsx from "clsx";

Splide.defaults = {
    drag: "free",
    snap: true,
    keyboard: true,
    pagination: false,
    i18n: {
        pageX: "Gehe zur Seite %s",
        play: "Starte automatisches Sliden",
        pause: "Pausiere automatisches Sliden",
        slideLabel: "%s von %s",
        carousel: "Karussell",
    },
};

const disabledButtonClass = "splide__arrow--disabled";

function getI18n(name) {
    name = (name || "Slide|zur|eine").split("|");
    return {
        prev: `Gehe ${name[1]} vorherigen ${name[0]}`,
        next: `Gehe ${name[1]} nächsten ${name[0]}`,
        first: `Gehe ${name[1]} ersten ${name[0]}`,
        last: `Gehe ${name[1]} letzten ${name[0]}`,
        slideX: `Gehe ${name[1]} ${name[0]} %s`,
        select: `Selektiere ${name[2]} ${name[0]} zum zeigen`,
    };
}

function getArrowClass({ arrowClass, arrowPrevClass, arrowNextClass }) {
    return {
        arrow: clsx("splide__arrow", arrowClass),
        prev: clsx("splide__arrow--prev", arrowPrevClass),
        next: clsx("splide__arrow--next", arrowNextClass),
    };
}

Alpine.data("syncSlider", (slideName) => ({
    init() {
        const main = new Splide(this.$refs.main, {
            rewind: true,
            pagination: false,
            arrows: false,
            i18n: getI18n(slideName || "Seite|zur|eine"),
            drag: true,
            gap: 10,
        });
        const nav = new Splide(this.$refs.nav, {
            gap: 10,
            rewind: true,
            pagination: false,
            isNavigation: true,
            i18n: getI18n(slideName || "Seite|zur|eine"),
            autoWidth: true,
            classes: {
                prev: "splide__arrow--prev -left-10",
                next: "splide__arrow--next -right-10",
            },
        });
        main.sync(nav);
        main.mount();
        nav.mount({ URLHash });
    },
}));

Alpine.data("slider", (config) => ({
    index: 0,
    maxIndex: 0,
    slides: null,
    prevArrow: null,
    nextArrow: null,
    getSlide: () => {},
    init() {
        const { slideName, arrowClass, arrowPrevClass, arrowNextClass, hash } = config;
        const splide = new Splide(this.$root, {
            classes: getArrowClass({ arrowClass, arrowPrevClass, arrowNextClass }),
            i18n: getI18n(slideName),
        });
        if (hash) {
            splide.mount({ URLHash });
        } else {
            splide.mount();
        }
        const components = splide.Components;
        const { prev, next } = components.Arrows.arrows;
        this.prevArrow = prev;
        this.nextArrow = next;
        this.getSlide = components.Slides.getAt;
        this.maxIndex = components.Slides.getLength() - 1;
        splide.on("active", ({ index }) => {
            this.index = index;
            this.notify();
        });
        splide.on("autoplay:playing", (rate) => {
            // Go to the first slide after the last slide
            if (rate == 1 && this.maxIndex == this.index) {
                splide.go(0);
            }
        });
    },
    item: (index) => ({
        "x-intersect:enter.full"() {
            // It is the first item
            if (index === 0) {
                this.prevArrow.classList.add(disabledButtonClass);
            }
            // It is the last item
            if (index >= this.maxIndex) {
                this.nextArrow.classList.add(disabledButtonClass);
            }
        },
        "x-intersect:leave.full"() {
            // It is the first item
            if (index === 0) {
                this.prevArrow.classList.remove(disabledButtonClass);
            }
            // It is the last item
            if (index >= this.maxIndex) {
                this.nextArrow.classList.remove(disabledButtonClass);
            }
        },
        "@mouseenter"() {
            this.notify(index);
        },
        "@focusin"() {
            this.notify(index);
        },
    }),
    notify(hover) {
        // Dispatch event on index change and hover
        const slideIndex = hover != undefined ? hover : this.index;
        const slide = this.getSlide(slideIndex).slide;
        this.$dispatch("notify", { hover, index: this.index, slide, splide: this.splide });
    },
}));
